import React, { useEffect, useState } from "react";

import Header from "../../components/Headers/Header.js";
import { supabase } from "../../lib/supabaseClient.ts";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import ReactSelect from "react-select";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { useNavigate } from "react-router-dom";


const customSelectStyles = {
  control: (base, state) => ({
    ...base,
    borderRadius: "0.375rem",
    borderColor: state.isFocused ? "#4a90e2" : "#ced4da", // blue on focus, gray otherwise
    boxShadow: state.isFocused ? "0 0 0 1px #4a90e2" : "none",
    "&:hover": { borderColor: "#4a90e2" },
    minHeight: "38px",
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  singleValue: (base) => ({
    ...base,
    color: "#333",
  }),
};

// const Products = () => {
//     const [products, setProducts] = useState([]);
//     const [showModal, setShowModal] = useState(false);
//     const [isEditing, setIsEditing] = useState(false);
//     const [selectedProduct, setSelectedProduct] = useState(null);
//     const [categories, setCategories] = useState([]);
//     const [subcategories, setSubcategories] = useState([]);
//     const [searchText, setSearchText] = useState("");
// const [selectedCategory, setSelectedCategory] = useState("");
// const [selectedSubcategory, setSelectedSubcategory] = useState("");
// const [filterNew, setFilterNew] = useState(false);
// const [filterBest, setFilterBest] = useState(false);
// const [filterInStock, setFilterInStock] = useState(false);
// const [filterOutOfStock, setFilterOutOfStock] = useState(false);

// const navigate= useNavigate();

//     const [formData, setFormData] = useState({
//         name: '',
//         category: [],
//         subcategory: [],   // <-- FIXED
//         description:"",
//         price_range: '',
//         brand: '',
//         image: null,
//             weight: '', // ✅ ADD THIS

//     });
//     useEffect(() => {
//         fetchProducts();
//         fetchCategories();
//         fetchSubcategories();
//     }, []);

//     async function fetchCategories() {
//         const { data, error } = await supabase.from("categories").select("*");
//         if (error) {
//             console.error("Failed to fetch categories:", error.message);
//             return;
//         }
//         setCategories(data);
//     }

//     async function fetchSubcategories() {
//         const { data, error } = await supabase.from("subcategories").select("*");
//         if (error) {
//             console.error("Failed to fetch subcategories:", error.message);
//             return;
//         }
//         setSubcategories(data);
//     }

//     async function uploadImage(file) {
//         const cleanedName = file.name.replace(/\s+/g, '-');
//         const fileName = `${Date.now()}-${cleanedName}`;

//         // Check if file already exists
//         const { data: existing, error: checkError } = await supabase
//             .storage
//             .from('animalia')
//             .list('', { search: fileName });

//         if (checkError) {
//             toast.error("❌ Failed to check existing images");
//             throw checkError;
//         }

//         if (existing && existing.length > 0) {
//             toast.info("ℹ️ Image already exists. Skipping upload.");
//             const { data } = supabase.storage.from('animalia').getPublicUrl(fileName);
//             return data.publicUrl;
//         }

//         const { error } = await supabase.storage.from('animalia').upload(fileName, file);
//         if (error) {
//             toast.error("❌ Image upload failed");
//             throw error;
//         }

//         const { data } = supabase.storage.from('animalia').getPublicUrl(fileName);
//         toast.success("✅ Image uploaded");
//         return data.publicUrl;
//     }

// // ✅ FIXED: handleSaveProduct - Properly store arrays as JSON
// async function handleSaveProduct() {
//   try {
//     let imageUrl = selectedProduct?.image;
//     if (formData.image && formData.image instanceof File) {
//       imageUrl = await uploadImage(formData.image);
//     }

//     const payload = {
//       name: formData.name,
//       // ✅ Store as JSON string for Supabase
//       category: JSON.stringify(formData.category),
//       subcategory: JSON.stringify(formData.subcategory),
//       price_range: formData.price_range,
//       brand: formData.brand,
//       image: imageUrl,
//       description: formData.description || null,
//         weight: formData.weight || null, 

//     };

//     if (isEditing) {
//       await supabase.from('products').update(payload).eq('id', selectedProduct.id);
//       toast.success("✅ Product updated");
//     } else {
//       await supabase.from('products').insert([payload]);
//       toast.success("✅ Product added");
//     }

//     setShowModal(false);
//     fetchProducts();
//   } catch (err) {
//     console.error("Save failed:", err.message);
//     toast.error(`❌ Save failed: ${err.message}`);
//   }
// }

//     async function handleDeleteProduct(id) {
//         try {
//             if (!window.confirm("Are you sure you want to delete this product?")) return;

//             const { error } = await supabase.from("products").delete().eq("id", id);

//             if (error) throw error;

//             setProducts((prev) => prev.filter((prod) => prod.id !== id));
//             toast.success("🗑️ Product deleted");
//         } catch (err) {
//             toast.error(`❌ Delete failed: ${err.message}`);
//         }
//     }
//  // Update 'new' field for product globally
//   const toggleNewGlobal = async (productId) => {
//     // find product index
//     const productIndex = products.findIndex(p => p.id === productId);
//     if (productIndex === -1) return;

//     // toggle new value
//     const newValue = !products[productIndex].new;

//     // Optimistically update UI
//     const updatedProducts = [...products];
//     updatedProducts[productIndex] = {
//       ...updatedProducts[productIndex],
//       new: newValue
//     };
//     setProducts(updatedProducts);

//     // Update backend
//     const { error } = await supabase
//       .from('products')
//       .update({ new: newValue })
//       .eq('id', productId);

//     if (error) {
//       alert('Erreur lors de la mise à jour');
//       // revert UI if backend update fails
//       updatedProducts[productIndex].new = !newValue;
//       setProducts(updatedProducts);
//     }
//   };
// const toggleBestGlobal = async (productId) => {
//   const productIndex = products.findIndex(p => p.id === productId);
//   if (productIndex === -1) return;

//   const newValue = !products[productIndex].best;

//   const updatedProducts = [...products];
//   updatedProducts[productIndex] = {
//     ...updatedProducts[productIndex],
//     best: newValue
//   };
//   setProducts(updatedProducts);

//   const { error } = await supabase
//     .from('products')
//     .update({ best: newValue })
//     .eq('id', productId);

//   if (error) {
//     alert('Erreur lors de la mise à jour');
//     updatedProducts[productIndex].best = !newValue;
//     setProducts(updatedProducts);
//   }
// };

// // ✅ FIXED: openForm - Parse JSON when loading existing product
// function openForm(product = null) {
//   setIsEditing(!!product);
//   setSelectedProduct(product);

//   let categories = [];
//   let subcategories = [];

//   if (product) {
//     // Parse category
//     try {
//       categories = typeof product.category === 'string' 
//         ? JSON.parse(product.category) 
//         : Array.isArray(product.category) 
//           ? product.category 
//           : [product.category];
//     } catch {
//       categories = product.category ? [product.category] : [];
//     }

//     // Parse subcategory
//     try {
//       subcategories = typeof product.subcategory === 'string' 
//         ? JSON.parse(product.subcategory) 
//         : Array.isArray(product.subcategory) 
//           ? product.subcategory 
//           : [product.subcategory];
//     } catch {
//       subcategories = product.subcategory ? [product.subcategory] : [];
//     }
//   }

//   setFormData({
//     name: product?.name || '',
//     category: categories,
//     subcategory: subcategories,
//     price_range: product?.price_range || '',
//     brand: product?.brand || '',
//     description: product?.description || "",
//     image: null,
//         weight: product?.weight || '', 
//   });

//   setShowModal(true);
// }



//     useEffect(() => {
//         fetchProducts();
//     }, []);

// const itemsPerPage = 9;
//   const [currentPage, setCurrentPage] = useState(1);
// // ✅ FIXED: filteredProducts - Proper array handling
// const filteredProducts = products
//   .filter(product =>
//     product.name.toLowerCase().includes(searchText.toLowerCase())
//   )
//   .filter(product => {
//     // Parse categories
//     let productCategories = [];
//     try {
//       productCategories = typeof product.category === 'string' 
//         ? JSON.parse(product.category) 
//         : Array.isArray(product.category) 
//           ? product.category 
//           : [product.category];
//     } catch {
//       productCategories = product.category ? [product.category] : [];
//     }

//     // Parse subcategories
//     let productSubcategories = [];
//     try {
//       productSubcategories = typeof product.subcategory === 'string' 
//         ? JSON.parse(product.subcategory) 
//         : Array.isArray(product.subcategory) 
//           ? product.subcategory 
//           : [product.subcategory];
//     } catch {
//       productSubcategories = product.subcategory ? [product.subcategory] : [];
//     }

//     // Normalize
//     productCategories = productCategories.map(c => c?.trim().toLowerCase()).filter(Boolean);
//     productSubcategories = productSubcategories.map(s => s?.trim().toLowerCase()).filter(Boolean);

//     const selectedCat = selectedCategory?.trim().toLowerCase();
//     const selectedSub = selectedSubcategory?.trim().toLowerCase();

//     // Match category
//     if (selectedCat && !productCategories.includes(selectedCat)) return false;

//     // Match subcategory (only if category matches)
//     if (selectedSub && !productSubcategories.includes(selectedSub)) return false;

//     return true;
//   })
//   .filter(product => filterNew ? product.new === true : true)
//   .filter(product => filterBest ? product.best === true : true)
//   .filter(product => {
//     const status = (product.stock_status || "").trim().toLowerCase();
//     if (filterInStock) return status === "en stock";
//     if (filterOutOfStock) return status === "rupture de stock";
//     return true;
//   });


// const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);

// const currentProducts = filteredProducts.slice(
//   (currentPage - 1) * itemsPerPage,
//   currentPage * itemsPerPage
// );

//   // Handle page change
//   const goToPage = (page) => {
//     if (page < 1 || page > totalPages) return;
//     setCurrentPage(page);
//   };


//     async function fetchProducts() {
//         const { data, error } = await supabase.from("products").select("*").order("created_at", { ascending: false });
//         ;
//         if (error) return console.error("Fetch failed:", error.message);

//         const updatedProducts = await Promise.all(
//             data.map(async (product) => {
//                 const filename = product.image?.split("/").pop();
//                 const { data: urlData } = supabase.storage.from("animalia").getPublicUrl(filename);
//                 return {
//                     ...product,
//                     image: urlData?.publicUrl || "https://via.placeholder.com/150",
//                 };
//             })
//         );

//         setProducts(updatedProducts);
//     }
// const toggleStockStatus = async (productId) => {
//   const productIndex = products.findIndex(p => p.id === productId);
//   if (productIndex === -1) return;

//   // Toggle between "en stock" and "rupture de stock"
//   const newValue = products[productIndex].stock_status === "en stock" ? "rupture de stock" : "en stock";

//   // Optimistic UI update
//   const updatedProducts = [...products];
//   updatedProducts[productIndex] = {
//     ...updatedProducts[productIndex],
//     stock_status: newValue
//   };
//   setProducts(updatedProducts);

//   // Update backend
//   const { error } = await supabase
//     .from('products')
//     .update({ stock_status: newValue })
//     .eq('id', productId);

//   if (error) {
//     toast.error("❌ Erreur lors de la mise à jour du stock");
//     // Revert UI if update fails
//     updatedProducts[productIndex].stock_status = products[productIndex].stock_status;
//     setProducts(updatedProducts);
//   }
// };

//     return (
//         <>
// <Modal isOpen={showModal} toggle={() => setShowModal(false)} centered>
//   <ModalHeader >
//     {isEditing ? "Modifier le produit" : "Ajouter un produit"}
//     {/* X button already handled by toggle prop in reactstrap ModalHeader */}
//      <button
//     type="button"
//     className="close"
//     onClick={() => setShowModal(false)}
//     style={{
//       position: "absolute",
//       top: "10px",
//       right: "10px",
//       border: "none",
//       background: "transparent",
//       fontSize: "1.5rem",
//       cursor: "pointer",
//     }}
//   >
//     ×
//   </button>
//   </ModalHeader>

//   <ModalBody>
//     {/* Name */}
//     <div className="mb-3">
//       <label htmlFor="nameInput" className="form-label">Nom</label>
//       <input
//         type="text"
//         id="nameInput"
//         className="form-control"
//         placeholder="Nom"
//         value={formData.name}
//         onChange={e => setFormData({ ...formData, name: e.target.value })}
//       />
//     </div>

//     {/* Category */}
//     <div className="mb-3">
//       <label className="form-label">Catégorie</label>
//       <ReactSelect
//   isMulti
//   styles={customSelectStyles}
//   options={categories.map(cat => ({ value: cat.name, label: cat.name }))}
//   value={formData.category.map(c => ({ value: c, label: c }))}

//   onChange={(selected) =>
//     setFormData({
//       ...formData,
//     category: selected ? selected.map(opt => opt.value) : []
//     })
//   }
// />

//     </div>

//     {/* Subcategory */}
//    <div className="mb-3">
//   <label className="form-label">Sous-catégorie</label>

//  <ReactSelect
//   isMulti
//   isDisabled={formData.category.length === 0}
//   styles={customSelectStyles}

//   options={subcategories
//     .filter(sub => {
//       const catName = categories.find(cat => cat.id === sub.category_id)?.name;
//       return formData.category.includes(catName);
//     })
//     .map(sub => ({ value: sub.name, label: sub.name }))
//   }

//   value={
//     formData.subcategory.map(s => ({ value: s, label: s }))
//   }

//   onChange={(selected) =>
//     setFormData({
//       ...formData,
//       subcategory: selected ? selected.map(opt => opt.value) : []
//     })
//   }
// />
// </div>


//     {/* Price */}
//     <div className="mb-3">
//       <label htmlFor="priceRangeInput" className="form-label">Plage de prix</label>
//       <input
//         type="text"
//         id="priceRangeInput"
//         className="form-control"
//         placeholder="Prix"
//         value={formData.price_range}
//         onChange={e => setFormData({ ...formData, price_range: e.target.value })}
//       />
//         <p style={{ fontSize: '0.85rem', color: '#555', marginTop: '4px' }}>
//     ⚠️ Si le prix comporte des centimes, par exemple 10,500 DT, veuillez le saisir comme 10,5
//   </p>
//     </div>
// <div className="mb-3">
//   <label htmlFor="weightInput" className="form-label">Poids</label>
//   <input
//     type="text"
//     id="weightInput"
//     className="form-control"
//     placeholder="ex: 500g, 1kg, 250ml, 1L"
//     value={formData.weight}
//     onChange={e => setFormData({ ...formData, weight: e.target.value })}
//   />
//   <small className="text-muted">Entrez le poids avec l'unité (g, kg, ml, L...)</small>
// </div>
//     {/* Brand */}
//     <div className="mb-3">
//       <label htmlFor="brandInput" className="form-label">Marque</label>
//       <input
//         type="text"
//         id="brandInput"
//         className="form-control"
//         placeholder="Marque"
//         value={formData.brand}
//         onChange={e => setFormData({ ...formData, brand: e.target.value })}
//       />
//     </div>

//     {/* Image */}
//     <div className="mb-4">
//       <label className="form-label fw-bold">Image</label>
//       <input
//         type="file"
//         className="form-control"
//         onChange={e => setFormData({ ...formData, image: e.target.files[0] })}
//       />
//     </div>

//     {/* ✅ Description field for products with no variations */}
//     {(!formData.variations || formData.variations.length === 0) && (
//       <div className="mb-3">
//         <label htmlFor="descriptionInput" className="form-label">Description</label>
//         <textarea
//           id="descriptionInput"
//           className="form-control"
//           placeholder="Description du produit"
//           rows={4}
//           value={formData.description || ""}
//           onChange={e => setFormData({ ...formData, description: e.target.value })}
//         />
//         {!formData.description && <small className="text-muted">Aucune description disponible</small>}
//       </div>
//     )}
//   </ModalBody>

//   <ModalFooter>
//     <Button color="secondary" onClick={() => setShowModal(false)}>Annuler</Button>
//     <Button color="success" onClick={handleSaveProduct}>
//       {isEditing ? "Mettre à jour" : "Ajouter"}
//     </Button>
//   </ModalFooter>
// </Modal>


//             <Header />
//             <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
// <div className="d-flex flex-wrap gap-2 mb-3">
//   {/* Search Input */}
//   <input
//     type="text"
//     className="form-control"
//     placeholder="Rechercher par nom..."
//     value={searchText}
//     onChange={(e) => {
//       setSearchText(e.target.value);
//       setCurrentPage(1);
//     }}
//     style={{ flex: 1, minWidth: "200px" }} // grows to fill available space
//   />

//   {/* Category Filter */}
//   <div style={{ width: "200px" }}>
//     {/* <ReactSelect
//       styles={customSelectStyles}
//       options={[{ value: "", label: "Toutes catégories" }, ...categories.map(cat => ({ value: cat.name, label: cat.name }))]}
//       value={selectedCategory ? { value: selectedCategory, label: selectedCategory } : { value: "", label: "Toutes catégories" }}
//       onChange={(selected) => {
//         setSelectedCategory(selected?.value || "");
//         setSelectedSubcategory(""); // reset subcategory when category changes
//         setCurrentPage(1);
//       }}
//       placeholder="Catégorie"
//     /> */}
//    {/* ✅ Category Filter - FIXED: Use selectedCategory state */}
//   <div style={{ width: "200px" }}>
//     <ReactSelect
//       styles={customSelectStyles}
//       options={[
//         { value: "", label: "Toutes catégories" },
//         ...categories.map(cat => ({ value: cat.name, label: cat.name }))
//       ]}
//       value={selectedCategory 
//         ? { value: selectedCategory, label: selectedCategory } 
//         : { value: "", label: "Toutes catégories" }
//       }
//       onChange={(selected) => {
//         setSelectedCategory(selected?.value || "");
//         setSelectedSubcategory(""); // Reset subcategory when category changes
//         setCurrentPage(1);
//       }}
//       placeholder="Catégorie"
//     />
//   </div>

//   {/* ✅ Subcategory Filter - FIXED: Show only when category is selected */}
//   <div style={{ width: "200px" }}>
//     <ReactSelect
//       styles={customSelectStyles}
//       isDisabled={!selectedCategory}
//       options={[
//         { value: "", label: "Toutes sous-catégories" },
//         ...subcategories
//           .filter(sub => {
//             const cat = categories.find(c => c.name === selectedCategory);
//             return cat ? sub.category_id === cat.id : false;
//           })
//           .map(sub => ({ value: sub.name, label: sub.name }))
//       ]}
//       value={selectedSubcategory 
//         ? { value: selectedSubcategory, label: selectedSubcategory } 
//         : { value: "", label: "Toutes sous-catégories" }
//       }
//       onChange={(selected) => {
//         setSelectedSubcategory(selected?.value || "");
//         setCurrentPage(1);
//       }}
//       placeholder="Sous-catégorie"
//     />
//   </div>
// </div>

  
// </div>

//    <div className="container-fluid" style={{ overflowX: "hidden", paddingLeft: "15px", paddingRight: "15px" ,marginLeft:"-10PX",marginTop:"10px"}}>
//     <div className="d-flex gap-2 mb-3">
//   {/* Nouveau Filter */}
//   <label
//     className={`d-flex align-items-center gap-2 px-3 py-1 rounded-full font-semibold cursor-pointer transition-all ${
//       filterNew ? "bg-pink-100 text-pink-600" : "bg-gray-200 text-gray-600 hover:bg-pink-50"
//     }`}
//   >
//     <input
//       type="checkbox"
//       checked={filterNew}
//       onChange={() => { setFilterNew(!filterNew); setCurrentPage(1); }}
//       className="w-4 h-4 cursor-pointer"
//     />
//     Nouveau
//   </label>

//   {/* Meilleur Filter */}
//   <label
//     className={`d-flex align-items-center gap-2 px-3 py-1 rounded-full font-semibold cursor-pointer transition-all ${
//       filterBest ? "bg-pink-100 text-pink-600" : "bg-gray-200 text-gray-600 hover:bg-pink-50"
//     }`}
//   >
//     <input
//       type="checkbox"
//       checked={filterBest}
//       onChange={() => { setFilterBest(!filterBest); setCurrentPage(1); }}
//       className="w-4 h-4 cursor-pointer"
//     />
//     Meilleur
//   </label>


//   {/* En stock Filter */}
// <label
//   className={`d-flex align-items-center gap-2 px-3 py-1 rounded-full font-semibold cursor-pointer transition-all ${
//     filterInStock ? "bg-green-100 text-green-600" : "bg-gray-200 text-gray-600 hover:bg-green-50"
//   }`}
// >
//   <input
//     type="checkbox"
//     checked={filterInStock}
//     onChange={() => { 
//       setFilterInStock(!filterInStock); 
//       setFilterOutOfStock(false); // optional: reset opposite filter
//       setCurrentPage(1); 
//     }}
//     className="w-4 h-4 cursor-pointer"
//   />
//   En stock
// </label>

// {/* Rupture de stock Filter */}
// <label
//   className={`d-flex align-items-center gap-2 px-3 py-1 rounded-full font-semibold cursor-pointer transition-all ${
//     filterOutOfStock ? "bg-red-100 text-red-600" : "bg-gray-200 text-gray-600 hover:bg-red-50"
//   }`}
// >
//   <input
//     type="checkbox"
//     checked={filterOutOfStock}
//     onChange={() => { 
//       setFilterOutOfStock(!filterOutOfStock); 
//       setFilterInStock(false); // optional: reset opposite filter
//       setCurrentPage(1); 
//     }}
//     className="w-4 h-4 cursor-pointer"
//   />
//   Rupture de stock
// </label>

// </div>

//       <div className="row">
//         <div className="col-12">

//             <div className="card-header border-0 d-flex justify-content-between align-items-center">
//               <h3 className="mb-0">Produits</h3>
//               <button className="btn" onClick={() => openForm(null)}>+ Ajouter Produit</button>
//             </div>

// <div
//   className="row p-4 g-3"
//     style={{ transform: "translateX(-120px)" }}

// >              {currentProducts.map((product) => (


    
    
//                <div
//   key={product.id}
//   className="col-12 col-md-4"
//   style={{ cursor: "pointer", padding: "2.5px" }} // half of 5px gap to each side
// >

//                 <div
//   className="card h-100 product-card border-0"
//   style={{
//     borderRadius: "16px",
//     overflow: "hidden",
//     transition: "transform 0.3s ease, box-shadow 0.3s ease",
//     boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
//     backgroundColor: "#fff",
//     position: "relative",
//     width: "100%",
//     maxHeight:"1000px",
//     boxSizing: "border-box",
//     padding: "10px",
//         cursor: "pointer" // <-- makes it clear it's clickable

//   }}
//     onClick={() => navigate(`/admin/product/${product.id}`)} // <-- entire card clickable

// >
//   {/* Toggles Container */}
//   <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginBottom: "10px" }}>

//   {/* Nouveau Toggle */}
//   <label
//         onClick={(e) => e.stopPropagation()} // <-- prevent parent click

//     style={{
//       display: "flex",
//       alignItems: "center",
//       gap: "6px",
//       cursor: "pointer",
//       fontWeight: "600",
//       color: product.new ? "#ff4081" : "#888",
//       backgroundColor: product.new ? "#ffe6f0" : "#f0f0f0",
//       padding: "4px 8px",
//       borderRadius: "12px",
//       fontSize: "0.85rem",
//       transition: "all 0.2s ease"
//     }}
//   >
//     <input
//       type="checkbox"
//       checked={product.new}
//       onChange={() => toggleNewGlobal(product.id)}
//       style={{ width: "16px", height: "16px", cursor: "pointer" }}
//     />
//     Nouveau
//   </label>

//   {/* Meilleur Toggle */}
//   <label
//     style={{
//       display: "flex",
//       alignItems: "center",
//       gap: "6px",
//       cursor: "pointer",
//       fontWeight: "600",
//       color: product.best ? "#ff4081" : "#888",
//       backgroundColor: product.best ? "#ffe6f0" : "#f0f0f0",
//       padding: "4px 8px",
//       borderRadius: "12px",
//       fontSize: "0.85rem",
//       transition: "all 0.2s ease"
//     }}
//   >
//     <input
//       type="checkbox"
//       checked={product.best}
//       onChange={() => toggleBestGlobal(product.id)}
//       style={{ width: "16px", height: "16px", cursor: "pointer" }}
//     />
//     Meilleur
//   </label>

//   {/* Stock Status Toggle */}
//   <label
//     style={{
//       display: "flex",
//       alignItems: "center",
//       gap: "6px",
//       cursor: "pointer",
//       fontWeight: "600",
//       color: product.stock_status === "en stock" ? "green" : "red",
//       backgroundColor: product.stock_status === "en stock" ? "#e6ffe6" : "#ffe6e6",
//       padding: "4px 8px",
//       borderRadius: "12px",
//       fontSize: "0.85rem",
//       transition: "all 0.2s ease"
//     }}
//   >
//     <input
//       type="checkbox"
//       checked={product.stock_status === "en stock"}
//       onChange={() => toggleStockStatus(product.id)}
//       style={{ width: "16px", height: "16px", cursor: "pointer" }}
//     />
//     {product.stock_status === "en stock" ? "En stock" : "Rupture de stock"}
//   </label>

// </div>

//   {/* Product Image */}
//   <div
//     className="bg-white position-relative d-flex align-items-center justify-content-center"
//     style={{ height: "200px", backgroundColor: "#fff" }}
//     onMouseEnter={(e) => {
//       const icons = e.currentTarget.querySelector(".action-icons");
//       if (icons) icons.style.opacity = 1;
//     }}
//     onMouseLeave={(e) => {
//       const icons = e.currentTarget.querySelector(".action-icons");
//       if (icons) icons.style.opacity = 0;
//     }}
//         onClick={(e) => e.stopPropagation()} // ✅ prevent navigate when clicking icons container

//   >
//     <img
//       src={product.image}
//       alt={product.name}
//       className="img-fluid"
//       style={{
//         maxHeight: "100px",
//         objectFit: "contain",
//         cursor: "pointer",
//         maxWidth: "100%",
//         height: "auto",
//       }}
//       onClick={() => navigate(`/admin/product/${product.id}`)}
//     />
//     {product.promo && (
//       <span
//         className="badge bg-success position-absolute top-0 end-0 m-2 px-3 py-1"
//         style={{ borderRadius: "12px", fontSize: "0.75rem" }}
//       >
//         Promo
//       </span>
//     )}

//     <div
//       className="action-icons position-absolute bottom-0 start-50 translate-middle-x d-flex gap-2 mb-2"
//       style={{
//         opacity: 0,
//         transition: "opacity 0.3s ease",
//         backgroundColor: "rgba(255, 255, 255, 0.9)",
//         padding: "6px 10px",
//         borderRadius: "12px",
//       }}
//     >
//       <button
//         className="btn btn-sm"
//         style={{ color: "#ff4081" }}
//         title="Éditer"
//         onClick={() => openForm(product)}
//       >
//         <i className="fas fa-edit"></i>
//       </button>
//       <button
//         className="btn btn-sm btn-danger"
//         title="Supprimer"
//         onClick={() => handleDeleteProduct(product.id)}
//       >
//         <i className="fas fa-trash-alt"></i>
//       </button>
//     </div>
//   </div>

//   {/* Product Info */}
//  <div
//   className="card-body d-flex flex-column mb-6"
//   style={{
//     padding: "16px 16px",       // a bit more padding for spacing
//     backgroundColor: "#fff",
//     borderTop: "1px solid #eee",
//     minHeight: "200px",         // increased from 140px to 200px
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "flex-start",
//     gap: "4px"                  // slightly more gap for readability
//   }}
// >
//  <div
//     style={{
//       flex: 1,                // take remaining space
//       overflowY: "auto",      // scroll if content overflows
//       padding: "16px 16px",
//       borderTop: "1px solid #eee"
//     }}
//   >
//   <h5
//     className="card-title fw-bold"
//     style={{
//       fontSize: "1rem",
//       color: "#333",
//       marginBottom: "40px",
//       lineHeight: "1.3em"        // slightly taller line-height
//     }}
//   >
//     {product.name}
//   </h5>
// {(product.weight || product.brand || product.price_range) && (
//   <div
//     style={{
//       background: "#f9fafb",
//       padding: "12px 16px",
//       borderRadius: "10px",
//       display: "flex",
//       flexDirection: "column",
//       gap: "6px",
//       border: "1px solid #eee",
//     }}
//   >
//     {product.weight && (
//       <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//         <span style={{ fontSize: "0.85rem", color: "#888" }}>⚖️</span>
//         <span style={{ fontSize: "0.9rem", color: "#333" }}>
//           <strong style={{ fontWeight: 600 }}>Poids:</strong> {product.weight}
//         </span>
//       </div>
//     )}

//     {product.brand && (
//       <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//         <span style={{ fontSize: "0.85rem", color: "#888" }}>🏷️</span>
//         <span style={{ fontSize: "0.9rem", color: "#333" }}>
//           <strong style={{ fontWeight: 600 }}>Marque:</strong> {product.brand}
//         </span>
//       </div>
//     )}

//     {product.price_range && (
//       <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//         <span style={{ fontSize: "0.85rem", color: "#888" }}>💰</span>
//         <span style={{ fontSize: "0.9rem", color: "#ff4cbb" }}>
//           <strong style={{ fontWeight: 700 }}>Prix:</strong> {product.price_range} DT
//         </span>
//       </div>
//     )}
//   </div>
// )}

// {/* Catégories */}
// {(() => {
//   let categories = [];

//   try {
//     categories = Array.isArray(product.category)
//       ? product.category
//       : JSON.parse(product.category || "[]");
//   } catch {
//     categories = [];
//   }

//   return (
//     categories.length > 0 && (
//       <div style={{ marginBottom: "6px" }}>
//         <strong>Catégorie:</strong>
//         <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", marginTop: "4px" }}>
//           {categories.map((cat, index) => (
//             <span
//               key={index}
//               style={{
//                 backgroundColor: "#e8f5e9",
//                 color: "#2e7d32",
//                 padding: "4px 8px",
//                 borderRadius: "12px",
//                 fontSize: "0.8rem",
//                 fontWeight: "600",
//               }}
//             >
//               {cat}
//             </span>
//           ))}
//         </div>
//       </div>
//     )
//   );
// })()}

// {/* Sous-catégories */}
// {(() => {
//   let subcategories = [];

//   try {
//     subcategories = Array.isArray(product.subcategory)
//       ? product.subcategory
//       : JSON.parse(product.subcategory || "[]");
//   } catch {
//     subcategories = [];
//   }

//   return (
//     subcategories.length > 0 && (
//       <div style={{ marginBottom: "6px" }}>
//         <strong>Sous-catégorie:</strong>
//         <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", marginTop: "4px" }}>
//           {subcategories.map((sub, index) => (
//             <span
//               key={index}
//               style={{
//                 backgroundColor: "#e3f2fd",
//                 color: "#1565c0",
//                 padding: "4px 8px",
//                 borderRadius: "12px",
//                 fontSize: "0.8rem",
//                 fontWeight: "600",
//               }}
//             >
//               {sub}
//             </span>
//           ))}
//         </div>
//       </div>
//     )
//   );
// })()}




// </div>

// </div>


// </div>

//                 </div>
//               ))}
//             </div>

//             <div className=" py-4"     style={{ transform: "translateX(-160px)" }}
// >
//               <nav>
//                 <ul className="pagination justify-content-end mb-0">
//                   <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
//                     <button
//                       className="page-link"
//                       onClick={() => goToPage(currentPage - 1)}
//                       disabled={currentPage === 1}
//                     >
//                       <i className="fas fa-angle-left" />
//                     </button>
//                   </li>

//                   {[...Array(totalPages)].map((_, idx) => {
//                     const pageNum = idx + 1;
//                     return (
//                       <li key={pageNum} className={`page-item ${pageNum === currentPage ? "active" : ""}`}>
//                         <button
//                           className="page-link"
//                           onClick={() => goToPage(pageNum)}
//                         >
//                           {pageNum}
//                         </button>
//                       </li>
//                     );
//                   })}

//                   <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
//                     <button
//                       className="page-link"
//                       onClick={() => goToPage(currentPage + 1)}
//                       disabled={currentPage === totalPages}
//                     >
//                       <i className="fas fa-angle-right" />
//                     </button>
//                   </li>
//                 </ul>
//               </nav>
//             </div>
          
//         </div>
//       </div>
//     </div>


//         </>
//     );
// };
const Products = () => {
    const [products, setProducts] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [categories, setCategories] = useState([]);
    const [subcategories, setSubcategories] = useState([]);
    const [searchText, setSearchText] = useState("");
const [selectedCategory, setSelectedCategory] = useState("");
const [selectedSubcategory, setSelectedSubcategory] = useState("");
const [filterNew, setFilterNew] = useState(false);
const [filterBest, setFilterBest] = useState(false);
const [filterInStock, setFilterInStock] = useState(false);
const [filterOutOfStock, setFilterOutOfStock] = useState(false);

const navigate= useNavigate();

    const [formData, setFormData] = useState({
        name: '',
        category: [],
        subcategory: [],
        description:"",
        price_range: '',
        brand: '',
        image: null,
        weight: '',
        composition: '',
        analysis: '',
        ingredients: '',
        antioxidants: '',
        energy: '',
    });
    
    useEffect(() => {
        fetchProducts();
        fetchCategories();
        fetchSubcategories();
    }, []);

    async function fetchCategories() {
        const { data, error } = await supabase.from("categories").select("*");
        if (error) {
            console.error("Failed to fetch categories:", error.message);
            return;
        }
        setCategories(data);
    }

    async function fetchSubcategories() {
        const { data, error } = await supabase.from("subcategories").select("*");
        if (error) {
            console.error("Failed to fetch subcategories:", error.message);
            return;
        }
        setSubcategories(data);
    }

    async function uploadImage(file) {
        const cleanedName = file.name.replace(/\s+/g, '-');
        const fileName = `${Date.now()}-${cleanedName}`;

        // Check if file already exists
        const { data: existing, error: checkError } = await supabase
            .storage
            .from('animalia')
            .list('', { search: fileName });

        if (checkError) {
            toast.error("❌ Failed to check existing images");
            throw checkError;
        }

        if (existing && existing.length > 0) {
            toast.info("ℹ️ Image already exists. Skipping upload.");
            const { data } = supabase.storage.from('animalia').getPublicUrl(fileName);
            return data.publicUrl;
        }

        const { error } = await supabase.storage.from('animalia').upload(fileName, file);
        if (error) {
            toast.error("❌ Image upload failed");
            throw error;
        }

        const { data } = supabase.storage.from('animalia').getPublicUrl(fileName);
        toast.success("✅ Image uploaded");
        return data.publicUrl;
    }

// ✅ FIXED: handleSaveProduct - Properly store arrays as JSON
async function handleSaveProduct() {
  try {
    let imageUrl = selectedProduct?.image;
    if (formData.image && formData.image instanceof File) {
      imageUrl = await uploadImage(formData.image);
    }

    const payload = {
      name: formData.name,
      category: JSON.stringify(formData.category),
      subcategory: JSON.stringify(formData.subcategory),
      price_range: formData.price_range,
      brand: formData.brand,
      image: imageUrl,
      description: formData.description || null,
      weight: formData.weight || null,
      composition: formData.composition || null,
      analysis: formData.analysis || null,
      ingredients: formData.ingredients || null,
      antioxidants: formData.antioxidants || null,
      energy: formData.energy || null,
    };

    if (isEditing) {
      await supabase.from('products').update(payload).eq('id', selectedProduct.id);
      toast.success("✅ Product updated");
    } else {
      await supabase.from('products').insert([payload]);
      toast.success("✅ Product added");
    }

    setShowModal(false);
    fetchProducts();
  } catch (err) {
    console.error("Save failed:", err.message);
    toast.error(`❌ Save failed: ${err.message}`);
  }
}

    async function handleDeleteProduct(id) {
        try {
            if (!window.confirm("Are you sure you want to delete this product?")) return;

            const { error } = await supabase.from("products").delete().eq("id", id);

            if (error) throw error;

            setProducts((prev) => prev.filter((prod) => prod.id !== id));
            toast.success("🗑️ Product deleted");
        } catch (err) {
            toast.error(`❌ Delete failed: ${err.message}`);
        }
    }
 // Update 'new' field for product globally
  const toggleNewGlobal = async (productId) => {
    // find product index
    const productIndex = products.findIndex(p => p.id === productId);
    if (productIndex === -1) return;

    // toggle new value
    const newValue = !products[productIndex].new;

    // Optimistically update UI
    const updatedProducts = [...products];
    updatedProducts[productIndex] = {
      ...updatedProducts[productIndex],
      new: newValue
    };
    setProducts(updatedProducts);

    // Update backend
    const { error } = await supabase
      .from('products')
      .update({ new: newValue })
      .eq('id', productId);

    if (error) {
      alert('Erreur lors de la mise à jour');
      // revert UI if backend update fails
      updatedProducts[productIndex].new = !newValue;
      setProducts(updatedProducts);
    }
  };
const toggleBestGlobal = async (productId) => {
  const productIndex = products.findIndex(p => p.id === productId);
  if (productIndex === -1) return;

  const newValue = !products[productIndex].best;

  const updatedProducts = [...products];
  updatedProducts[productIndex] = {
    ...updatedProducts[productIndex],
    best: newValue
  };
  setProducts(updatedProducts);

  const { error } = await supabase
    .from('products')
    .update({ best: newValue })
    .eq('id', productId);

  if (error) {
    alert('Erreur lors de la mise à jour');
    updatedProducts[productIndex].best = !newValue;
    setProducts(updatedProducts);
  }
};

// ✅ FIXED: openForm - Parse JSON when loading existing product
function openForm(product = null) {
  setIsEditing(!!product);
  setSelectedProduct(product);

  let categories = [];
  let subcategories = [];

  if (product) {
    // Parse category
    try {
      categories = typeof product.category === 'string' 
        ? JSON.parse(product.category) 
        : Array.isArray(product.category) 
          ? product.category 
          : [product.category];
    } catch {
      categories = product.category ? [product.category] : [];
    }

    // Parse subcategory
    try {
      subcategories = typeof product.subcategory === 'string' 
        ? JSON.parse(product.subcategory) 
        : Array.isArray(product.subcategory) 
          ? product.subcategory 
          : [product.subcategory];
    } catch {
      subcategories = product.subcategory ? [product.subcategory] : [];
    }
  }

  setFormData({
    name: product?.name || '',
    category: categories,
    subcategory: subcategories,
    price_range: product?.price_range || '',
    brand: product?.brand || '',
    description: product?.description || "",
    image: null,
    weight: product?.weight || '',
    composition: product?.composition || '',
    analysis: product?.analysis || '',
    ingredients: product?.ingredients || '',
    antioxidants: product?.antioxidants || '',
    energy: product?.energy || '',
  });

  setShowModal(true);
}



    useEffect(() => {
        fetchProducts();
    }, []);

const itemsPerPage = 9;
  const [currentPage, setCurrentPage] = useState(1);
// ✅ FIXED: filteredProducts - Proper array handling
const filteredProducts = products
  .filter(product =>
    product.name.toLowerCase().includes(searchText.toLowerCase())
  )
  .filter(product => {
    // Parse categories
    let productCategories = [];
    try {
      productCategories = typeof product.category === 'string' 
        ? JSON.parse(product.category) 
        : Array.isArray(product.category) 
          ? product.category 
          : [product.category];
    } catch {
      productCategories = product.category ? [product.category] : [];
    }

    // Parse subcategories
    let productSubcategories = [];
    try {
      productSubcategories = typeof product.subcategory === 'string' 
        ? JSON.parse(product.subcategory) 
        : Array.isArray(product.subcategory) 
          ? product.subcategory 
          : [product.subcategory];
    } catch {
      productSubcategories = product.subcategory ? [product.subcategory] : [];
    }

    // Normalize
    productCategories = productCategories.map(c => c?.trim().toLowerCase()).filter(Boolean);
    productSubcategories = productSubcategories.map(s => s?.trim().toLowerCase()).filter(Boolean);

    const selectedCat = selectedCategory?.trim().toLowerCase();
    const selectedSub = selectedSubcategory?.trim().toLowerCase();

    // Match category
    if (selectedCat && !productCategories.includes(selectedCat)) return false;

    // Match subcategory (only if category matches)
    if (selectedSub && !productSubcategories.includes(selectedSub)) return false;

    return true;
  })
  .filter(product => filterNew ? product.new === true : true)
  .filter(product => filterBest ? product.best === true : true)
  .filter(product => {
    const status = (product.stock_status || "").trim().toLowerCase();
    if (filterInStock) return status === "en stock";
    if (filterOutOfStock) return status === "rupture de stock";
    return true;
  });


const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);

const currentProducts = filteredProducts.slice(
  (currentPage - 1) * itemsPerPage,
  currentPage * itemsPerPage
);

  // Handle page change
  const goToPage = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };


    async function fetchProducts() {
        const { data, error } = await supabase.from("products").select("*").order("created_at", { ascending: false });
        ;
        if (error) return console.error("Fetch failed:", error.message);

        const updatedProducts = await Promise.all(
            data.map(async (product) => {
                const filename = product.image?.split("/").pop();
                const { data: urlData } = supabase.storage.from("animalia").getPublicUrl(filename);
                return {
                    ...product,
                    image: urlData?.publicUrl || "https://via.placeholder.com/150",
                };
            })
        );

        setProducts(updatedProducts);
    }
const toggleStockStatus = async (productId) => {
  const productIndex = products.findIndex(p => p.id === productId);
  if (productIndex === -1) return;

  // Toggle between "en stock" and "rupture de stock"
  const newValue = products[productIndex].stock_status === "en stock" ? "rupture de stock" : "en stock";

  // Optimistic UI update
  const updatedProducts = [...products];
  updatedProducts[productIndex] = {
    ...updatedProducts[productIndex],
    stock_status: newValue
  };
  setProducts(updatedProducts);

  // Update backend
  const { error } = await supabase
    .from('products')
    .update({ stock_status: newValue })
    .eq('id', productId);

  if (error) {
    toast.error("❌ Erreur lors de la mise à jour du stock");
    // Revert UI if update fails
    updatedProducts[productIndex].stock_status = products[productIndex].stock_status;
    setProducts(updatedProducts);
  }
};

    return (
        <>
<Modal isOpen={showModal} toggle={() => setShowModal(false)} centered size="lg">
  <ModalHeader >
    {isEditing ? "Modifier le produit" : "Ajouter un produit"}
     <button
    type="button"
    className="close"
    onClick={() => setShowModal(false)}
    style={{
      position: "absolute",
      top: "10px",
      right: "10px",
      border: "none",
      background: "transparent",
      fontSize: "1.5rem",
      cursor: "pointer",
    }}
  >
    ×
  </button>
  </ModalHeader>

  <ModalBody style={{ maxHeight: "70vh", overflowY: "auto" }}>
    {/* Name */}
    <div className="mb-3">
      <label htmlFor="nameInput" className="form-label">Nom</label>
      <input
        type="text"
        id="nameInput"
        className="form-control"
        placeholder="Nom"
        value={formData.name}
        onChange={e => setFormData({ ...formData, name: e.target.value })}
      />
    </div>

    {/* Category */}
    <div className="mb-3">
      <label className="form-label">Catégorie</label>
      <ReactSelect
  isMulti
  styles={customSelectStyles}
  options={categories.map(cat => ({ value: cat.name, label: cat.name }))}
  value={formData.category.map(c => ({ value: c, label: c }))}

  onChange={(selected) =>
    setFormData({
      ...formData,
    category: selected ? selected.map(opt => opt.value) : []
    })
  }
/>

    </div>

    {/* Subcategory */}
   <div className="mb-3">
  <label className="form-label">Sous-catégorie</label>

 <ReactSelect
  isMulti
  isDisabled={formData.category.length === 0}
  styles={customSelectStyles}

  options={subcategories
    .filter(sub => {
      const catName = categories.find(cat => cat.id === sub.category_id)?.name;
      return formData.category.includes(catName);
    })
    .map(sub => ({ value: sub.name, label: sub.name }))
  }

  value={
    formData.subcategory.map(s => ({ value: s, label: s }))
  }

  onChange={(selected) =>
    setFormData({
      ...formData,
      subcategory: selected ? selected.map(opt => opt.value) : []
    })
  }
/>
</div>


    {/* Price */}
    <div className="mb-3">
      <label htmlFor="priceRangeInput" className="form-label">Plage de prix</label>
      <input
        type="text"
        id="priceRangeInput"
        className="form-control"
        placeholder="Prix"
        value={formData.price_range}
        onChange={e => setFormData({ ...formData, price_range: e.target.value })}
      />
        <p style={{ fontSize: '0.85rem', color: '#555', marginTop: '4px' }}>
    ⚠️ Si le prix comporte des centimes, par exemple 10,500 DT, veuillez le saisir comme 10,5
  </p>
    </div>
<div className="mb-3">
  <label htmlFor="weightInput" className="form-label">Poids</label>
  <input
    type="text"
    id="weightInput"
    className="form-control"
    placeholder="ex: 500g, 1kg, 250ml, 1L"
    value={formData.weight}
    onChange={e => setFormData({ ...formData, weight: e.target.value })}
  />
  <small className="text-muted">Entrez le poids avec l'unité (g, kg, ml, L...)</small>
</div>
    {/* Brand */}
    <div className="mb-3">
      <label htmlFor="brandInput" className="form-label">Marque</label>
      <input
        type="text"
        id="brandInput"
        className="form-control"
        placeholder="Marque"
        value={formData.brand}
        onChange={e => setFormData({ ...formData, brand: e.target.value })}
      />
    </div>

    {/* Image */}
    <div className="mb-4">
      <label className="form-label fw-bold">Image</label>
      <input
        type="file"
        className="form-control"
        onChange={e => setFormData({ ...formData, image: e.target.files[0] })}
      />
    </div>

    {/* ✅ Description field */}
    <div className="mb-3">
      <label htmlFor="descriptionInput" className="form-label">Description</label>
      <textarea
        id="descriptionInput"
        className="form-control"
        placeholder="Description du produit"
        rows={3}
        value={formData.description || ""}
        onChange={e => setFormData({ ...formData, description: e.target.value })}
      />
    </div>

    {/* NEW FIELDS */}
    <hr className="my-4" />
    <h5 className="mb-3">Informations nutritionnelles et composition</h5>

    {/* Composition */}
    <div className="mb-3">
      <label htmlFor="compositionInput" className="form-label">Composition</label>
      <textarea
        id="compositionInput"
        className="form-control"
        placeholder="Composition du produit"
        rows={3}
        value={formData.composition || ""}
        onChange={e => setFormData({ ...formData, composition: e.target.value })}
      />
      <small className="text-muted">Ex: Protéines 25%, Matières grasses 15%, etc.</small>
    </div>

    {/* Analysis */}
    <div className="mb-3">
      <label htmlFor="analysisInput" className="form-label">Analyse</label>
      <textarea
        id="analysisInput"
        className="form-control"
        placeholder="Analyse nutritionnelle"
        rows={3}
        value={formData.analysis || ""}
        onChange={e => setFormData({ ...formData, analysis: e.target.value })}
      />
      <small className="text-muted">Analyse détaillée des valeurs nutritionnelles</small>
    </div>

    {/* Ingredients */}
    <div className="mb-3">
      <label htmlFor="ingredientsInput" className="form-label">Ingrédients</label>
      <textarea
        id="ingredientsInput"
        className="form-control"
        placeholder="Liste des ingrédients"
        rows={3}
        value={formData.ingredients || ""}
        onChange={e => setFormData({ ...formData, ingredients: e.target.value })}
      />
      <small className="text-muted">Liste complète des ingrédients</small>
    </div>

    {/* Antioxidants */}
    <div className="mb-3">
      <label htmlFor="antioxidantsInput" className="form-label">Antioxydants</label>
      <textarea
        id="antioxidantsInput"
        className="form-control"
        placeholder="Antioxydants contenus"
        rows={2}
        value={formData.antioxidants || ""}
        onChange={e => setFormData({ ...formData, antioxidants: e.target.value })}
      />
      <small className="text-muted">Ex: Vitamine E, Romarin, etc.</small>
    </div>

    {/* Energy */}
    <div className="mb-3">
      <label htmlFor="energyInput" className="form-label">Énergie</label>
      <input
        type="text"
        id="energyInput"
        className="form-control"
        placeholder="Valeur énergétique"
        value={formData.energy || ""}
        onChange={e => setFormData({ ...formData, energy: e.target.value })}
      />
      <small className="text-muted">Ex: 350 kcal/100g</small>
    </div>
  </ModalBody>

  <ModalFooter>
    <Button color="secondary" onClick={() => setShowModal(false)}>Annuler</Button>
    <Button color="success" onClick={handleSaveProduct}>
      {isEditing ? "Mettre à jour" : "Ajouter"}
    </Button>
  </ModalFooter>
</Modal>


            <Header />
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
<div className="d-flex flex-wrap gap-2 mb-3">
  {/* Search Input */}
  <input
    type="text"
    className="form-control"
    placeholder="Rechercher par nom..."
    value={searchText}
    onChange={(e) => {
      setSearchText(e.target.value);
      setCurrentPage(1);
    }}
    style={{ flex: 1, minWidth: "200px" }} // grows to fill available space
  />

  {/* Category Filter */}
  <div style={{ width: "200px" }}>
   {/* ✅ Category Filter - FIXED: Use selectedCategory state */}
  <div style={{ width: "200px" }}>
    <ReactSelect
      styles={customSelectStyles}
      options={[
        { value: "", label: "Toutes catégories" },
        ...categories.map(cat => ({ value: cat.name, label: cat.name }))
      ]}
      value={selectedCategory 
        ? { value: selectedCategory, label: selectedCategory } 
        : { value: "", label: "Toutes catégories" }
      }
      onChange={(selected) => {
        setSelectedCategory(selected?.value || "");
        setSelectedSubcategory(""); // Reset subcategory when category changes
        setCurrentPage(1);
      }}
      placeholder="Catégorie"
    />
  </div>

  {/* ✅ Subcategory Filter - FIXED: Show only when category is selected */}
  <div style={{ width: "200px" }}>
    <ReactSelect
      styles={customSelectStyles}
      isDisabled={!selectedCategory}
      options={[
        { value: "", label: "Toutes sous-catégories" },
        ...subcategories
          .filter(sub => {
            const cat = categories.find(c => c.name === selectedCategory);
            return cat ? sub.category_id === cat.id : false;
          })
          .map(sub => ({ value: sub.name, label: sub.name }))
      ]}
      value={selectedSubcategory 
        ? { value: selectedSubcategory, label: selectedSubcategory } 
        : { value: "", label: "Toutes sous-catégories" }
      }
      onChange={(selected) => {
        setSelectedSubcategory(selected?.value || "");
        setCurrentPage(1);
      }}
      placeholder="Sous-catégorie"
    />
  </div>
</div>

  
</div>

   <div className="container-fluid" style={{ overflowX: "hidden", paddingLeft: "15px", paddingRight: "15px" ,marginLeft:"-10PX",marginTop:"10px"}}>
    <div className="d-flex gap-2 mb-3">
  {/* Nouveau Filter */}
  <label
    className={`d-flex align-items-center gap-2 px-3 py-1 rounded-full font-semibold cursor-pointer transition-all ${
      filterNew ? "bg-pink-100 text-pink-600" : "bg-gray-200 text-gray-600 hover:bg-pink-50"
    }`}
  >
    <input
      type="checkbox"
      checked={filterNew}
      onChange={() => { setFilterNew(!filterNew); setCurrentPage(1); }}
      className="w-4 h-4 cursor-pointer"
    />
    Nouveau
  </label>

  {/* Meilleur Filter */}
  <label
    className={`d-flex align-items-center gap-2 px-3 py-1 rounded-full font-semibold cursor-pointer transition-all ${
      filterBest ? "bg-pink-100 text-pink-600" : "bg-gray-200 text-gray-600 hover:bg-pink-50"
    }`}
  >
    <input
      type="checkbox"
      checked={filterBest}
      onChange={() => { setFilterBest(!filterBest); setCurrentPage(1); }}
      className="w-4 h-4 cursor-pointer"
    />
    Meilleur
  </label>


  {/* En stock Filter */}
<label
  className={`d-flex align-items-center gap-2 px-3 py-1 rounded-full font-semibold cursor-pointer transition-all ${
    filterInStock ? "bg-green-100 text-green-600" : "bg-gray-200 text-gray-600 hover:bg-green-50"
  }`}
>
  <input
    type="checkbox"
    checked={filterInStock}
    onChange={() => { 
      setFilterInStock(!filterInStock); 
      setFilterOutOfStock(false); // optional: reset opposite filter
      setCurrentPage(1); 
    }}
    className="w-4 h-4 cursor-pointer"
  />
  En stock
</label>

{/* Rupture de stock Filter */}
<label
  className={`d-flex align-items-center gap-2 px-3 py-1 rounded-full font-semibold cursor-pointer transition-all ${
    filterOutOfStock ? "bg-red-100 text-red-600" : "bg-gray-200 text-gray-600 hover:bg-red-50"
  }`}
>
  <input
    type="checkbox"
    checked={filterOutOfStock}
    onChange={() => { 
      setFilterOutOfStock(!filterOutOfStock); 
      setFilterInStock(false); // optional: reset opposite filter
      setCurrentPage(1); 
    }}
    className="w-4 h-4 cursor-pointer"
  />
  Rupture de stock
</label>

</div>

      <div className="row">
        <div className="col-12">

            <div className="card-header border-0 d-flex justify-content-between align-items-center">
              <h3 className="mb-0">Produits</h3>
              <button className="btn" onClick={() => openForm(null)}>+ Ajouter Produit</button>
            </div>

<div
  className="row p-4 g-3"
    style={{ transform: "translateX(-120px)" }}

>              {currentProducts.map((product) => (


    
    
               <div
  key={product.id}
  className="col-12 col-md-4"
  style={{ cursor: "pointer", padding: "2.5px" }} // half of 5px gap to each side
>

                <div
  className="card h-100 product-card border-0"
  style={{
    borderRadius: "16px",
    overflow: "hidden",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
    backgroundColor: "#fff",
    position: "relative",
    width: "100%",
    maxHeight:"1000px",
    boxSizing: "border-box",
    padding: "10px",
        cursor: "pointer" // <-- makes it clear it's clickable

  }}
    onClick={() => navigate(`/admin/product/${product.id}`)} // <-- entire card clickable

>
  {/* Toggles Container */}
  <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginBottom: "10px" }}>

  {/* Nouveau Toggle */}
  <label
        onClick={(e) => e.stopPropagation()} // <-- prevent parent click

    style={{
      display: "flex",
      alignItems: "center",
      gap: "6px",
      cursor: "pointer",
      fontWeight: "600",
      color: product.new ? "#ff4081" : "#888",
      backgroundColor: product.new ? "#ffe6f0" : "#f0f0f0",
      padding: "4px 8px",
      borderRadius: "12px",
      fontSize: "0.85rem",
      transition: "all 0.2s ease"
    }}
  >
    <input
      type="checkbox"
      checked={product.new}
      onChange={() => toggleNewGlobal(product.id)}
      style={{ width: "16px", height: "16px", cursor: "pointer" }}
    />
    Nouveau
  </label>

  {/* Meilleur Toggle */}
  <label
    style={{
      display: "flex",
      alignItems: "center",
      gap: "6px",
      cursor: "pointer",
      fontWeight: "600",
      color: product.best ? "#ff4081" : "#888",
      backgroundColor: product.best ? "#ffe6f0" : "#f0f0f0",
      padding: "4px 8px",
      borderRadius: "12px",
      fontSize: "0.85rem",
      transition: "all 0.2s ease"
    }}
  >
    <input
      type="checkbox"
      checked={product.best}
      onChange={() => toggleBestGlobal(product.id)}
      style={{ width: "16px", height: "16px", cursor: "pointer" }}
    />
    Meilleur
  </label>

  {/* Stock Status Toggle */}
  <label
    style={{
      display: "flex",
      alignItems: "center",
      gap: "6px",
      cursor: "pointer",
      fontWeight: "600",
      color: product.stock_status === "en stock" ? "green" : "red",
      backgroundColor: product.stock_status === "en stock" ? "#e6ffe6" : "#ffe6e6",
      padding: "4px 8px",
      borderRadius: "12px",
      fontSize: "0.85rem",
      transition: "all 0.2s ease"
    }}
  >
    <input
      type="checkbox"
      checked={product.stock_status === "en stock"}
      onChange={() => toggleStockStatus(product.id)}
      style={{ width: "16px", height: "16px", cursor: "pointer" }}
    />
    {product.stock_status === "en stock" ? "En stock" : "Rupture de stock"}
  </label>

</div>

  {/* Product Image */}
  <div
    className="bg-white position-relative d-flex align-items-center justify-content-center"
    style={{ height: "200px", backgroundColor: "#fff" }}
    onMouseEnter={(e) => {
      const icons = e.currentTarget.querySelector(".action-icons");
      if (icons) icons.style.opacity = 1;
    }}
    onMouseLeave={(e) => {
      const icons = e.currentTarget.querySelector(".action-icons");
      if (icons) icons.style.opacity = 0;
    }}
        onClick={(e) => e.stopPropagation()} // ✅ prevent navigate when clicking icons container

  >
    <img
      src={product.image}
      alt={product.name}
      className="img-fluid"
      style={{
        maxHeight: "100px",
        objectFit: "contain",
        cursor: "pointer",
        maxWidth: "100%",
        height: "auto",
      }}
      onClick={() => navigate(`/admin/product/${product.id}`)}
    />
    {product.promo && (
      <span
        className="badge bg-success position-absolute top-0 end-0 m-2 px-3 py-1"
        style={{ borderRadius: "12px", fontSize: "0.75rem" }}
      >
        Promo
      </span>
    )}

    <div
      className="action-icons position-absolute bottom-0 start-50 translate-middle-x d-flex gap-2 mb-2"
      style={{
        opacity: 0,
        transition: "opacity 0.3s ease",
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        padding: "6px 10px",
        borderRadius: "12px",
      }}
    >
      <button
        className="btn btn-sm"
        style={{ color: "#ff4081" }}
        title="Éditer"
        onClick={() => openForm(product)}
      >
        <i className="fas fa-edit"></i>
      </button>
      <button
        className="btn btn-sm btn-danger"
        title="Supprimer"
        onClick={() => handleDeleteProduct(product.id)}
      >
        <i className="fas fa-trash-alt"></i>
      </button>
    </div>
  </div>

  {/* Product Info */}
 <div
  className="card-body d-flex flex-column mb-6"
  style={{
    padding: "16px 16px",       // a bit more padding for spacing
    backgroundColor: "#fff",
    borderTop: "1px solid #eee",
    minHeight: "200px",         // increased from 140px to 200px
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    gap: "4px"                  // slightly more gap for readability
  }}
>
 <div
    style={{
      flex: 1,                // take remaining space
      overflowY: "auto",      // scroll if content overflows
      padding: "16px 16px",
      borderTop: "1px solid #eee"
    }}
  >
  <h5
    className="card-title fw-bold"
    style={{
      fontSize: "1rem",
      color: "#333",
      marginBottom: "40px",
      lineHeight: "1.3em"        // slightly taller line-height
    }}
  >
    {product.name}
  </h5>
{(product.weight || product.brand || product.price_range) && (
  <div
    style={{
      background: "#f9fafb",
      padding: "12px 16px",
      borderRadius: "10px",
      display: "flex",
      flexDirection: "column",
      gap: "6px",
      border: "1px solid #eee",
    }}
  >
    {product.weight && (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <span style={{ fontSize: "0.85rem", color: "#888" }}>⚖️</span>
        <span style={{ fontSize: "0.9rem", color: "#333" }}>
          <strong style={{ fontWeight: 600 }}>Poids:</strong> {product.weight}
        </span>
      </div>
    )}

    {product.brand && (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <span style={{ fontSize: "0.85rem", color: "#888" }}>🏷️</span>
        <span style={{ fontSize: "0.9rem", color: "#333" }}>
          <strong style={{ fontWeight: 600 }}>Marque:</strong> {product.brand}
        </span>
      </div>
    )}

    {product.price_range && (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <span style={{ fontSize: "0.85rem", color: "#888" }}>💰</span>
        <span style={{ fontSize: "0.9rem", color: "#ff4cbb" }}>
          <strong style={{ fontWeight: 700 }}>Prix:</strong> {product.price_range} DT
        </span>
      </div>
    )}
  </div>
)}

{/* Catégories */}
{(() => {
  let categories = [];

  try {
    categories = Array.isArray(product.category)
      ? product.category
      : JSON.parse(product.category || "[]");
  } catch {
    categories = [];
  }

  return (
    categories.length > 0 && (
      <div style={{ marginBottom: "6px" }}>
        <strong>Catégorie:</strong>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", marginTop: "4px" }}>
          {categories.map((cat, index) => (
            <span
              key={index}
              style={{
                backgroundColor: "#e8f5e9",
                color: "#2e7d32",
                padding: "4px 8px",
                borderRadius: "12px",
                fontSize: "0.8rem",
                fontWeight: "600",
              }}
            >
              {cat}
            </span>
          ))}
        </div>
      </div>
    )
  );
})()}

{/* Sous-catégories */}
{(() => {
  let subcategories = [];

  try {
    subcategories = Array.isArray(product.subcategory)
      ? product.subcategory
      : JSON.parse(product.subcategory || "[]");
  } catch {
    subcategories = [];
  }

  return (
    subcategories.length > 0 && (
      <div style={{ marginBottom: "6px" }}>
        <strong>Sous-catégorie:</strong>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", marginTop: "4px" }}>
          {subcategories.map((sub, index) => (
            <span
              key={index}
              style={{
                backgroundColor: "#e3f2fd",
                color: "#1565c0",
                padding: "4px 8px",
                borderRadius: "12px",
                fontSize: "0.8rem",
                fontWeight: "600",
              }}
            >
              {sub}
            </span>
          ))}
        </div>
      </div>
    )
  );
})()}




</div>

</div>


</div>

                </div>
              ))}
            </div>

            <div className=" py-4"     style={{ transform: "translateX(-160px)" }}
>
              <nav>
                <ul className="pagination justify-content-end mb-0">
                  <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                    <button
                      className="page-link"
                      onClick={() => goToPage(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      <i className="fas fa-angle-left" />
                    </button>
                  </li>

                  {[...Array(totalPages)].map((_, idx) => {
                    const pageNum = idx + 1;
                    return (
                      <li key={pageNum} className={`page-item ${pageNum === currentPage ? "active" : ""}`}>
                        <button
                          className="page-link"
                          onClick={() => goToPage(pageNum)}
                        >
                          {pageNum}
                        </button>
                      </li>
                    );
                  })}

                  <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                    <button
                      className="page-link"
                      onClick={() => goToPage(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      <i className="fas fa-angle-right" />
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          
        </div>
      </div>
    </div>


        </>
    );
};
export default Products;

